import {
  OnboardingTopUpBalanceFailure,
  OnboardingTopUpBalanceSuccess,
  OnboardingImportEmployees,
  OnboardingImportVehicles,
  OnboardingCompanyPolicy,
  OnboardingImportSummary,
  OnboardingImportRemoval,
  OnboardingSubscriptions,
  OnboardingTopUpBalance,
  OnboardingEmployees,
  OnboardingVehicles,
  OnboardingFinish,
} from '@pages/onboarding';
import { CostCenterRoute, CostCenters, CostCenter } from '@pages/cost-centers';
import { OnboardingRoute, ProtectedRoute, CompanyRoute } from '@core/router';
import { Invoicing } from '@pages/files-reports/views/invoicing/invoicing';
import Impersonate from '@pages/auth/views/impersonate/impersonate';
import { TransactionHistory, Reports } from '@pages/files-reports';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { CompanyNotFound, NotFound } from '@pages/not-found';
import { EmployeesProfile } from '@pages/employees-profile';
import { AcceptConsents, SelectCompany } from '@pages/auth';
import { Notifications } from '@pages/notifications';
import { ParkingSpots } from '@pages/parking-spots';
import { FilesReports } from '@pages/files-reports';
import { Subscription } from '@pages/subscription';
import { Callback } from '@pages/auth/views';
import { Dashboard } from '@pages/dashboard';
import { Employees } from '@pages/employees';
import { Vehicles } from '@pages/vehicles';
import { Routes } from '@shared/enums';
import { Users } from '@pages/users';
import { Help } from '@pages/help';

export const router = createBrowserRouter(
  [
    {
      path: Routes.ROOT,
      element: <ProtectedRoute />,
      children: [
        { index: true, element: <SelectCompany /> },
        { path: Routes.ACCEPT_CONSENTS, element: <AcceptConsents /> },
        {
          path: Routes.ONBOARDING,
          element: <OnboardingRoute />,
          children: [
            { path: Routes.ADD_VEHICLES, element: <OnboardingVehicles /> },
            { path: Routes.ADD_EMPLOYEES, element: <OnboardingEmployees /> },
            { path: Routes.IMPORT_SUMMARY, element: <OnboardingImportSummary /> },
            { path: Routes.IMPORT_REMOVAL, element: <OnboardingImportRemoval /> },
            { path: Routes.IMPORT_VEHICLES, element: <OnboardingImportVehicles /> },
            { path: Routes.IMPORT_EMPLOYEES, element: <OnboardingImportEmployees /> },
            { path: Routes.TOP_UP_BALANCE, element: <OnboardingTopUpBalance /> },
            { path: Routes.TOP_UP_BALANCE_SUCCESS, element: <OnboardingTopUpBalanceSuccess /> },
            { path: Routes.TOP_UP_BALANCE_FAILED, element: <OnboardingTopUpBalanceFailure /> },
            { path: Routes.SUBSCRIPTIONS, element: <OnboardingSubscriptions /> },
            { path: Routes.COMPANY_POLICY, element: <OnboardingCompanyPolicy /> },
            { path: Routes.FINISH, element: <OnboardingFinish /> },
          ],
        },
        {
          path: Routes.COMPANY_ID,
          element: <CompanyRoute />,
          children: [
            { index: true, element: <Navigate to={Routes.DASHBOARD} replace /> },
            { path: Routes.DASHBOARD, element: <Dashboard /> },
            { path: Routes.EMPLOYEES, element: <Employees /> },
            { path: Routes.EMPLOYEE_PROFILES, element: <EmployeesProfile /> },
            { path: Routes.EMPLOYEE_PROFILE, element: <EmployeesProfile /> },
            { path: Routes.USERS, element: <Users /> },
            { path: Routes.VEHICLES, element: <Vehicles /> },
            { path: Routes.PARKING_SPOTS, element: <ParkingSpots /> },
            {
              path: Routes.COST_CENTER,
              element: <CostCenterRoute />,
              children: [
                { index: true, element: <CostCenters /> },
                { path: `:costCenterId`, element: <CostCenter /> },
              ],
            },
            { path: Routes.SUBSCRIPTION, element: <Subscription /> },
            {
              path: Routes.FILES_REPORTS,
              element: <FilesReports />,
              children: [
                { index: true, element: <Navigate to={Routes.TRANSACTION_HISTORY} replace /> },
                { path: Routes.TRANSACTION_HISTORY, element: <TransactionHistory /> },
                { path: Routes.INVOICING, element: <Invoicing /> },
                { path: Routes.REPORTS, element: <Reports /> },
              ],
            },
            { path: Routes.HELP, element: <Help /> },
            { path: Routes.NOTIFICATIONS, element: <Notifications /> },
            { path: Routes.WILDCARD, element: <CompanyNotFound /> },
          ],
        },
      ],
    },
    { path: Routes.IMPERSONATE, element: <Impersonate /> },
    { path: Routes.NOT_FOUND, element: <NotFound /> },
    { path: Routes.WILDCARD, element: <NotFound /> },
    { path: Routes.CALLBACK, element: <Callback /> },
  ],
  { basename: import.meta.env.VITE_BASE_PATH },
);
